import React, { useState } from "react";

function AssignedDetails(){
  const [showModal, setShowModal] = useState(false);

  const assignedEmails = [
    "abu@emayamtech.com",
    "faizal@emayamtech.com",
    "sur@emayamtech.com",
    "san@emayamtech.com",
  ];

  const comments = [
    `"This buyer is very professional and quick to respond. Make sure to prioritize their requests."`,
    `"Great buyer! They are clear about their requirements and make timely payments."`,
    `"The buyer has been cooperative and easy to work with. Maintain good communication with them."`,
  ];

  return (
    <div className="p-6 bg-white border-2 border-gray-300 rounded-md w-full">
      <h2 className="text-lg font-semibold mb-4 text-[#333333]">Assigned Details</h2>

      <div className="flex justify-between">
        {/* Left side */}
        <div className="flex flex-col gap-3 w-1/2">
          <div className="flex items-center gap-2">
            <p className="text-sm font-medium text-[#333333]">Assigned To :</p>
            {/* Dummy profile images */}
            <div className="flex -space-x-2">
              <img
                src="https://i.pravatar.cc/32?img=1"
                alt="profile"
                className="w-8 h-8 rounded-full border border-white"
              />
              <img
                src="https://i.pravatar.cc/32?img=2"
                alt="profile"
                className="w-8 h-8 rounded-full border border-white"
              />
              <img
                src="https://i.pravatar.cc/32?img=3"
                alt="profile"
                className="w-8 h-8 rounded-full border border-white"
              />
            </div>
            <button
              onClick={() => setShowModal(true)}
              className="text-blue-600 text-sm underline"
            >
              View all
            </button>
          </div>

          {/* Comments Section */}
          <div>
            <p className="text-sm font-medium text-[#333333]">Comments :</p>
            <div className="mt-1 p-2 px-3 border rounded bg-gray-50 text-xs h-24 overflow-y-scroll">
              {comments.map((comment, index) => (
                <p key={index}>{comment}</p>
              ))}
            </div>
          </div>
        </div>

        {/* Right side */}
        <div className="flex flex-col gap-3 px-3 text-sm w-1/2">
          <div className="flex justify-between">
            <span className="font-medium text-[#333333]">Completed by :</span>
            <span>25/01/2024</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-[#333333]">Priority :</span>
            <span className="text-red-600 font-semibold">High</span>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed  inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-96 p-6 relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-md font-semibold">Assigned To</h3>
              <button onClick={() => setShowModal(false)} className="text-xl font-bold">
                &times;
              </button>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {assignedEmails.map((email, index) => (
                <span
                  key={index}
                  className="bg-gray-100 text-sm px-2 py-1 rounded-md"
                >
                  {email}
                </span>
              ))}
            </div>

            <div className="flex justify-end mt-6">
              <button
                onClick={() => setShowModal(false)}
                className="bg-blue-600 text-white px-4 py-1 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignedDetails;
